module.exports = __webpack_public_path__ + "img/beer-rosa-blanca.61d2be7f.png";